// 006 (research R6; 001 FR-043): a route component that loads its screen with import() on first
// render, behind the chunk error boundary (Try again reloads the chunk) and a loading screen.
// Route files pass the import() themselves so Metro splits each screen into its own chunk.
import { type ComponentType, Suspense, useState } from "react";

import { lazyWithRetry } from "@/lib/lazyWithRetry";

import { ChunkErrorBoundary } from "./ChunkErrorBoundary";
import { LoadingScreen } from "./LoadingScreen";

export function lazyScreen<P extends object = object>(
  loader: () => Promise<{ default: ComponentType<P> }>,
): ComponentType<P> {
  function LazyScreen(props: P) {
    // Created per mount, so the import() runs only when the route renders (after its guard).
    const [{ Component, retry }] = useState(() => lazyWithRetry(loader));
    return (
      <ChunkErrorBoundary onRetry={retry}>
        <Suspense fallback={<LoadingScreen />}>
          <Component {...props} />
        </Suspense>
      </ChunkErrorBoundary>
    );
  }
  return LazyScreen;
}
